export class Login {
    mobile_no: string;
    otp: string;
}